import Vue from 'vue'

const state = {
    data: {
        isFooter: true,
        closeOnEscape: false,
        closeOnModal: false,
        showClose: false,
        width: "400px",
        appendToBody: true
    },
    map: {
        1: { content: [Vue.prototype.$t("code-lab/component/file-management/dialog-notify/observable.js_0"), Vue.prototype.$t("code-lab/component/file-management/dialog-notify/observable.js_1")] },
        2: { content: [Vue.prototype.$t("code-lab/component/file-management/dialog-notify/observable.js_2")] }
    }
}

export const store = Vue.observable(state)

export const mutations = {
    data (payload) {
        Object.assign(store, { data: { ...store.data, ...payload } })
    }
}
